module.exports = __webpack_public_path__ + "static/media/full-course.5e2b4d5f.jpg";